

import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "../axios";
// import logo from "../assets/logo.png";
// import authImage from "../assets/img3.png";
import "./auth.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
// import Select from 'react-select';
import { useTranslation } from "react-i18next";
import { useLanguage } from "../store/language-context";

const Register = () => {
  const { t } = useTranslation();
  const { URL } = useLanguage();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [nationalId, setNationalId] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [company, setCompany] = useState("");

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  // const [companyId, setCompanyId] = useState("");
  // const navigate = useNavigate();
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [nationalIdError, setNationalIdError] = useState("");
  // const handleCompanyChange = (selectedOption) => {
  //   setCompany(selectedOption);
  // };


  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setPhone(value);

    // Check if the phone number is between 10 and 15 digits
    const phonePattern = /^[0-9]{10,15}$/;
    if (value && !phonePattern.test(value)) {
      setPhoneError(t('register.phone-err'));
    } else {
      setPhoneError("");
    }
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    // Email validation pattern
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Validate the email
    if (value && !emailPattern.test(value)) {
      setEmailError(t('يرجى إدخال بريد إلكتروني صالح'));
    } else {
      setEmailError("");
    }
  };

  const handleNationalIdChange = (e) => {
    const value = e.target.value;
    setNationalId(value);

    // National ID validation: exactly 10 digits
    const nationalIdPattern = /^[0-9]{10}$/;
    if (value && !nationalIdPattern.test(value)) {
      setNationalIdError(t('رقم الهوية يجب أن يتكون من 10 أرقام فقط'));
    } else {
      setNationalIdError("");
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    if (
      !firstName ||
      !lastName ||
      !email ||
      !phone ||
      !password ||
      !confirmPassword

    ) {
      setErrors({ general: t('register.general-err') });
      setLoading(false);
      return;
    }

    if (password !== confirmPassword) {
      setErrors({ general: t('register.pass-err') });
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        `${URL}/register`,
        {
          first_name: firstName,
          last_name: lastName,
          email,
          phone,
          password,
          password_confirmation: confirmPassword,
          national_id: nationalId,
          subscription: isSubscribed ? "1" : "0",
          company_title: company,

        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const { token, user } = response.data.data;
      localStorage.setItem("token", token);
      localStorage.setItem("userEmail", user);
      localStorage.setItem("isLoggedIn", "true");
      Swal.fire("Success", t('contractual.done'), "success");
      // navigate("/");
      window.history.back();
    } catch (error) {
      const errorMessage =
        error.response?.data?.data?.join(", ") || "Registration failed";
      setErrors({ general: errorMessage });
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="form-part">
      <form onSubmit={handleSubmit}>
        <p>{t('hello')}</p>
        <h6>{t('register.create-email')}</h6>
        <div>
          <label>{t('contact.first-name')}</label>
          <input
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
        </div>
        <div>
          <label>{t('contact.last-name')}</label>
          <input
            type="text"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
        </div>
        <div>
          <label>
            {t('contact.nationalId')}
          </label>
          <input
            type="text" // Change type to 'text' for validation of digits as input type 'number' is problematic
            value={nationalId}
            onChange={handleNationalIdChange}
            required
            placeholder={nationalIdError}
          />
          {nationalIdError && <div className="error">{nationalIdError}</div>}
        </div>
        <div>
          <label>{t('contact.email')}</label>
          <input
            type="email"
            value={email}
            onChange={handleEmailChange}
            required
            placeholder={emailError}
          />
          {emailError && <div className="error">{emailError}</div>}
        </div>
        <div>
          <label>{t('contact.phone')}</label>
          <input
            type="text"
            value={phone}
            onChange={handlePhoneChange}
            required
            placeholder={phoneError}
          />
          {phoneError && <div className="error">{phoneError}</div>}
        </div>
        <div>
          <label>{t('contact.company')}</label>
          <input
            type="text"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
          />
        </div>

        <div className="pass new">
          <label>{t('register.enter-pass')}</label>
          <input
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <FontAwesomeIcon
            icon={showPassword ? faEye : faEyeSlash}
            onClick={() => setShowPassword((prev) => !prev)}
            className="password-toggle-icon"
          />
        </div>
        <div className="pass new">
          <label>{t('register.submit-pass')}</label>
          <input
            type={showConfirmPassword ? "text" : "password"}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          <FontAwesomeIcon
            icon={showConfirmPassword ? faEye : faEyeSlash}
            onClick={() => setShowConfirmPassword((prev) => !prev)}
            className="password-toggle-icon"
          />
        </div>
        <label className="terms mt-2">
          <input
            type="checkbox"
            checked={isSubscribed}
            onChange={(e) => setIsSubscribed(e.target.checked)}
          />
          <span>{t('register.i-agree-news')}</span>
        </label>
        <label className="terms">
          <input type="checkbox" required />
          <span>
            {t('contact.i-agree')} {" "}
            <Link to="/privacy">
              {t('contractual.company-privacy')}
            </Link>
          </span>
        </label>
        <div>
          <button type="submit" disabled={loading}>
            {loading ? `${t('custom.checking')}...` : t('register.create-email')}
          </button>
        </div>
        {errors.general && (
          <ul className="error-list">
            {(Array.isArray(errors.general)
              ? errors.general
              : [errors.general]
            ).map((error, index) => (
              <li key={index} className="error">
                {error}
              </li>
            ))}
          </ul>
        )}
      </form>
    </div>
  );
};

export default Register;